import React from 'react';

import { ButtonBar, ModalFormHeader } from '../index';

interface ConfirmationModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  icon?: string;
}

export function ConfirmationModal({
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  icon = 'warning'
}: ConfirmationModalProps) {
  return (
    <div className="form-container">
      <ModalFormHeader
        icon={icon}
        header="Confirmation"
      />
      
      <div className="confirmation-message">
        <p>{message}</p>
      </div>

      <ButtonBar
        handlePrimary={onConfirm}
        handleSecondary={onCancel}
        primaryText={confirmText}
        secondaryText={cancelText}
      />
    </div>
  );
}
